import React, { useMemo } from "react";
import Button from "../../../../component/button/Button";
import JobApplay from "../jobapplication/JobApplay";
import MicroJobApplay from "../jobapplication/MicroJobApplay";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NoJobMatch from "./NoJobMatch";
import SimilarJobs from "./SimilarJobs";
import "../../../../i18n/i18n";
import { useTranslation } from "react-i18next";
import useClientConfig from "../../../../config/careers/clientConfig";
import BackButton from "../../../../component/button/BackButton";
import { ShouldShowSalary } from "../../utils/commonHelper";


const OptionThreeJobView = (props: any) => {

    const { jobDataView, routerLocation, routeParams, titleSection, jobLogo, ApplayNowButton, listOfPoint,
        description, imgAndVideo, location, referenceNo, positionType, category, postedOn, searchControlFilter,
        clientDesign, navigateToJob, similarJobList } = props;

    const jobDetails = useSelector((state: any) => state.careers.jobDetails);

    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const languageSettings = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const { t } = useTranslation();
    const { clientSiteSettings } = useClientConfig();

    //by default showSimilarJobs is true
    const showSimilarJobs = clientSiteSettings?.showSimilarJobs !== undefined ? clientSiteSettings.showSimilarJobs : true;


    const applyPath = useMemo(() => {
        return routerLocation.pathname === `/view/${routeParams?.id}`;
    }, [routerLocation.pathname]);



    const content = useMemo(() => {
        if (clientDesign === "template_8_micro") {
            return !applyPath ? <MicroJobApplay /> : "";
        } else {
            return !applyPath ? <JobApplay /> : "";
        }

    }, [applyPath]);

    const navigate = useNavigate();
    const navigateToJobAlerts = () => {
        navigate("/job-alerts");
    };


    const salary = () => {
        return (
            <>
                <div className="d-flex">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.7432 0.672852V3.26562H9.37207V0.672852H10.7432ZM10.5762 15.0254V17.3896H9.20508V15.0254H10.5762ZM11.543 12.1426C11.543 11.8086 11.4814 11.5244 11.3584 11.29C11.2412 11.0557 11.0479 10.8477 10.7783 10.666C10.5146 10.4844 10.1572 10.3086 9.70605 10.1387C8.94434 9.8457 8.27344 9.53516 7.69336 9.20703C7.11914 8.87305 6.6709 8.45996 6.34863 7.96777C6.02637 7.46973 5.86523 6.83984 5.86523 6.07812C5.86523 5.35156 6.03809 4.72168 6.38379 4.18848C6.72949 3.65527 7.20703 3.24512 7.81641 2.95801C8.43164 2.66504 9.14648 2.51855 9.96094 2.51855C10.582 2.51855 11.1445 2.6123 11.6484 2.7998C12.1523 2.98145 12.5859 3.25098 12.9492 3.6084C13.3125 3.95996 13.5908 4.39062 13.7842 4.90039C13.9775 5.41016 14.0742 5.99316 14.0742 6.64941H11.5518C11.5518 6.29785 11.5137 5.9873 11.4375 5.71777C11.3613 5.44824 11.25 5.22266 11.1035 5.04102C10.9629 4.85937 10.793 4.72461 10.5938 4.63672C10.3945 4.54297 10.1748 4.49609 9.93457 4.49609C9.57715 4.49609 9.28418 4.56641 9.05566 4.70703C8.82715 4.84766 8.66016 5.03809 8.55469 5.27832C8.45508 5.5127 8.40527 5.78223 8.40527 6.08691C8.40527 6.38574 8.45801 6.64648 8.56348 6.86914C8.6748 7.0918 8.86523 7.29688 9.13477 7.48438C9.4043 7.66602 9.77344 7.85352 10.2422 8.04688C11.0039 8.33984 11.6719 8.65625 12.2461 8.99609C12.8203 9.33594 13.2686 9.75195 13.5908 10.2441C13.9131 10.7363 14.0742 11.3633 14.0742 12.125C14.0742 12.8809 13.8984 13.5254 13.5469 14.0586C13.1953 14.5859 12.7031 14.9902 12.0703 15.2715C11.4375 15.5469 10.7051 15.6846 9.87305 15.6846C9.33398 15.6846 8.79785 15.6143 8.26465 15.4736C7.73145 15.3271 7.24805 15.0928 6.81445 14.7705C6.38086 14.4482 6.03516 14.0205 5.77734 13.4873C5.51953 12.9482 5.39062 12.2861 5.39062 11.501H7.92188C7.92188 11.9287 7.97754 12.2861 8.08887 12.5732C8.2002 12.8545 8.34668 13.0801 8.52832 13.25C8.71582 13.4141 8.92676 13.5312 9.16113 13.6016C9.39551 13.6719 9.63281 13.707 9.87305 13.707C10.248 13.707 10.5557 13.6396 10.7959 13.5049C11.042 13.3701 11.2266 13.1855 11.3496 12.9512C11.4785 12.7109 11.543 12.4414 11.543 12.1426Z" fill="#3A3E54" /></svg>
                    <div className="add-start">
                        {" "}
                        {languageSettings?.jobView?.[0]?.salary}: <span className="add-avalue">{jobDetails?.data?.data?.job?.salary}</span>
                    </div>
                </div>
            </>
        );
    };


    return (
        <>
            <BackButton />
            {routerLocation.pathname ===
                `/view/${routeParams?.id}` ? (
                <>
                    <div className="mob-job-search-parent">
                        {jobDataView}
                    </div>
                </>
            ) : (
                ""
            )}
            {routerLocation.pathname === `/view/${routeParams?.id}` ?
                <>
                    <div className="opt3-view-page">
                        <div className="opt3-view-page-inner">
                            <div
                                className={`${routerLocation.pathname ===
                                    `/view/${routeParams?.id}`
                                    ? "opt3-view-page-left"
                                    : "opt3-view-page-left"
                                    }`}
                            >

                                <div className="opt3-view-page-left-inner">
                                    <div
                                        className={
                                            routerLocation.state !==
                                                `/view/${routeParams?.id}/apply-job`
                                                ? "opt3-view-page-left-inner-left"
                                                : "opt3-view-page-left-inner-left"
                                        }
                                    >
                                        {titleSection()}
                                        {/* <div className="d-lg-flex d-md-flex  d-flex d-sm-flex align-items-center job-view-desc-sec">
                                {jobDetailDownloadLink()}
                            </div> */}
                                        <div className="cust-opt3-list-point">{listOfPoint()}</div>
                                        <div>{description()}</div>
                                    </div>
                                    {routerLocation.pathname !==
                                        `/view/${routeParams?.id}/apply-job` ? (
                                        <div className="opt3-view-page-left-inner-right mob-joblogo">
                                            {jobLogo()}
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </div>


                                <div></div>

                                <div>{imgAndVideo()}</div>
                                <div
                                    className={`${routerLocation.pathname !==
                                        `/view/${routeParams?.id}/apply-job`
                                        ? "d-flex"
                                        : ""
                                        } pt-2`}
                                ></div>



                            </div>

                            <div className="opt3-view-page-right">

                                <div className="apply_job_wrap">
                                    {ApplayNowButton()}
                                </div>
                                <div className="opt3_job_list_points">
                                    <div className="job_list_points">
                                        <div className="job_list_points_inner">
                                            <div>{location()}</div>
                                            <div>{category()}</div>
                                            <div>{positionType()}</div>
                                            {ShouldShowSalary(jobDetails?.data?.data?.job?.salary) && (
                                                <div>{salary()}</div>
                                            )}
                                            <div>{referenceNo()}</div>
                                            <div>{postedOn()}</div>
                                        </div>
                                        {/* <a href="#" className="shareLink">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <mask id="mask0_7398_35130" maskUnits="userSpaceOnUse" x="0" y="1" width="12" height="10">
                                        <path d="M4.45324 9.13309L5.9981 8.24116C6.28132 8.07764 6.64684 8.17558 6.81036 8.45881C6.97388 8.74203 6.87594 9.10755 6.59271 9.27107L5.04785 10.163C3.62658 10.9836 1.80711 10.496 0.986543 9.07477C0.165971 7.6535 0.653496 5.83403 2.07477 5.01346L3.61963 4.12153C3.90285 3.95801 4.26837 4.05595 4.43189 4.33918C4.59541 4.6224 4.49747 4.98792 4.21425 5.15144L2.66938 6.04336C1.81971 6.53392 1.52589 7.63048 2.01645 8.48015C2.50701 9.32982 3.60356 9.62365 4.45324 9.13309ZM7.22441 2.04036L5.67955 2.93229C5.39633 3.09581 5.29839 3.46132 5.46191 3.74455C5.62543 4.02777 5.99095 4.12571 6.27417 3.96219L7.81903 3.07027C8.6687 2.57971 9.76526 2.87353 10.2558 3.7232C10.7464 4.57287 10.4526 5.66943 9.60288 6.15999L8.05802 7.05191C7.7748 7.21543 7.67686 7.58095 7.84038 7.86418C8.0039 8.1474 8.36941 8.24534 8.65264 8.08182L10.1975 7.18989C11.6188 6.36932 12.1063 4.54986 11.2857 3.12858C10.4652 1.70731 8.64569 1.21979 7.22441 2.04036ZM4.07626 7.29091C4.23978 7.57414 4.6053 7.67208 4.88852 7.50856L7.97824 5.7247C8.26147 5.56118 8.35941 5.19567 8.19589 4.91244C8.03237 4.62922 7.66685 4.53128 7.38363 4.6948L4.2939 6.47865C4.01068 6.64217 3.91274 7.00769 4.07626 7.29091Z" fill="white"/>
                                        </mask>
                                        <g mask="url(#mask0_7398_35130)">
                                        <rect width="12" height="12" fill="#3A3E54"/>
                                        </g>
                                    </svg> SHARE LINK
                                </a> */}
                                    </div>

                                    <div className="no_match_wrap ">
                                        <NoJobMatch navigateToJob={navigateToJob} navigateToJobAlerts={navigateToJobAlerts} {...props} />
                                    </div>
                                </div>


                            </div>




                        </div>



                        {routerLocation.pathname ===
                            `/view/${routeParams?.id}` ? (
                            <div className=" d-none d-lg-none container-inner mb-4">
                                <div className="d-sm-block d-md-block d-block control-container">
                                    <div className="d-flex justify-content-between py-4 px-2">
                                        <div className="mobile-search-view">{t("Continue Looking?")}</div>
                                        <div>
                                            <Button
                                                clasName="btn-new btn-primary-new"
                                                label={t("Search Jobs")}
                                                position="left"
                                                icon="pi pi-search"
                                                onClick={() => searchControlFilter()}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    {showSimilarJobs &&
                        <div className="similar_jobs_wrap">
                            <SimilarJobs similarJobList={similarJobList} />
                        </div>
                    }
                </>
                :
                null
            }
            {content}
        </>
    );
};

export default OptionThreeJobView;